import { combineLatest } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { indexPath, registerSub } from 'nike-re-framejs';
import DmsService from './services/DmsService';
import { dbPath } from '@/common/util';

registerSub('documentsUpload.ready', dbPath(['documentsUpload', 'config']));
registerSub('documentsUpload.slot.version', (db$, [, slot]) =>
    indexPath(['documentsUpload', 'model', 'selected', slot, 'version'])
);

registerSub('documentsUpload.extractUploaded', () =>
    indexPath(['documentsUpload', 'model']).pipe(map(DmsService.extractUploadedDocuments))
);

registerSub('documentsUpload.uploadProgress', (db$, [, slot, , page]) => {
    return indexPath(['documentsUpload', 'model', 'selected', slot, 'files', page, 'upload']);
});

registerSub('documentsUpload.hasFilesUploaded', (db$, [, slot]) => {
    return indexPath(['documentsUpload', 'model', 'selected', slot]).pipe(
        filter(sl => sl && sl.get('files')),
        map(
            sl =>
                sl.get('pages') ===
                sl
                    .get('files')
                    .countBy(file => file.getIn(['upload', 'done']))
                    .get(true)
        ),
        distinctUntilChanged()
    );
});

registerSub('documentsUpload.flowProgress', () => {
    const allSlots$ = indexPath(['documentsUpload', 'config']);
    const model$ = indexPath(['documentsUpload', 'model']);
    return combineLatest(allSlots$, model$, (allSlots, model) => {
        let progress = [0, 8];
        if (allSlots) {
            progress = [1, allSlots.count() * 2];
            if (model) {
                const slot = model.get('slot');
                progress[0] = 1 + (model.getIn(['selected', slot]) ? slot * 2 + 1 : slot * 2);
            }
        }
        return progress;
    }).pipe(distinctUntilChanged());
});
